import type { CountryCode } from '@shared-core/utils/phone'
import type { flags } from '@shared-images/flags'

export const SUPPORTED_COUNTRY_CODES = [
  'az',
  'am',
  'by',
  'kz',
  'kg',
  'md',
  'ru',
  'tj',
  'tm',
  'uz',
  'us',
  'vn',
] as const satisfies ReadonlyArray<CountryCode>

export type SupportedCountryCode = (typeof SUPPORTED_COUNTRY_CODES)[number]

export const PHONE_COUNTRY_CODES: CountryCode[] = ['ru', 'by', 'tj', 'kz', 'uz', 'kg']

export type Country = {
  code: CountryCode
  name: string
  dialCode: string
  flagKey: keyof typeof flags
}

export const CIS_COUNTRIES: Country[] = [
  { code: 'ru', name: 'Россия', dialCode: '+7', flagKey: 'ru' },
  { code: 'kz', name: 'Казахстан', dialCode: '+7', flagKey: 'kz' },
  { code: 'by', name: 'Беларусь', dialCode: '+375', flagKey: 'by' },
  { code: 'kg', name: 'Киргизия', dialCode: '+996', flagKey: 'kg' },
  { code: 'am', name: 'Армения', dialCode: '+374', flagKey: 'am' },
  { code: 'az', name: 'Азербайджан', dialCode: '+994', flagKey: 'az' },
  { code: 'md', name: 'Молдова', dialCode: '+373', flagKey: 'md' },
  { code: 'tj', name: 'Таджикистан', dialCode: '+992', flagKey: 'tj' },
  { code: 'tm', name: 'Туркменистан', dialCode: '+993', flagKey: 'tm' },
  { code: 'uz', name: 'Узбекистан', dialCode: '+998', flagKey: 'uz' },
]
export const RU_COUNTRY = CIS_COUNTRIES.find((country) => country.code === 'ru') ?? CIS_COUNTRIES[0]

// Санкционные страны, где не работают world-карты
export const SANCTIONED_COUNTRY_CODES = [
  'ru',
  'by',
  'cn',
  'jp',
  'sg',
  'au',
  'ua',
  'bg',
  'ir',
  'kp',
  'cu',
  've',
  'iq',
  'sy',
  'af',
  'al',
  'bi',
  'ht',
  'gw',
  'cd',
  'zw',
  'ye',
  'lb',
  'lr',
  'ly',
  'ml',
  'mm',
  'ni',
  'rw',
  'so',
  'sd',
  'sl',
  'cf',
  'er',
  'ss',
] as const satisfies ReadonlyArray<CountryCode & keyof typeof flags>

export type SanctionedCountryCode = (typeof SANCTIONED_COUNTRY_CODES)[number]
